import { DataType, InverterData, InverterDataComposer, ReadWrite, RegisterTable } from '../lib/inverter.model';
import { V3DeviceInputTypeChannelConfig } from './device-info';

export const V3GlobalSettings: Partial<RegisterTable> = {
  LANG: {
    address: 0x1034,
    name: 'Language',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Language',
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'language',
      options: [
        { value: 1, label: 'English' },
        { value: 2, label: 'Italian' },
      ],
    },
  },
};

const V3BatterySingleBatConfig: Partial<RegisterTable> = {
  AddressMask_Config_Basic2: {
    address: 0x1040,
    name: 'AddressMask_Config_Basic2',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of battery 2',
    quantity: 4,
    isMask: true,
  },
  BAT_CONFIG_ID: {
    address: 0x1044,
    name: 'Battery configuration ID',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery configuration ID [0-7]',
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'batteryConfigID',
      options: [
        { value: 0, label: 'Battery pack 1' },
        { value: 1, label: 'Battery pack 2' },
      ],
    },
  },
  BAT_CONFIG_ADDRESS_1: {
    address: 0x1045,
    name: 'Battery communication address',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery communication address',
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'batteryCommunicationAddress',
    },
  },
  BAT_CONFIG_PROTOCOL: {
    address: 0x1046,
    name: 'Battery communication protocol',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      Battery parameter-communication protocol
        0: Sofar Built-in BMS
        1: Pylontech's  Protocol
        2：Sofar's Protocol
        3：Amass
        4: LG
        5: Alpha ESS
        6: CATL
        7: Weco
        8：Fronus
        9：EMS
        10：Nilar`,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'batteryCommunicationProtocol',
      options: [
        { value: 0, label: 'Sofar Built-in BMS' },
        { value: 1, label: 'Pylontech' },
        { value: 2, label: 'Weco LV' },
        { value: 3, label: 'ZSX Azzurro' },
        { value: 4, label: 'LG' },
        { value: 5, label: 'Alpha ESS' },
        { value: 6, label: 'CATL' },
        { value: 7, label: 'Weco HV' },
        { value: 11, label: 'BTS 5K' },
      ],
    },
  },
  BAT_CONFIG_CURRENT_CHARGE_LIMIT: {
    address: 0x104B,
    name: 'Battery current charge limit',
    dataType: DataType.U16,
    unit: 'A',
    accuracy: 0.01,
    access: ReadWrite.ReadWrite,
    description: 'Battery current charge limit',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'batteryCurrentChargeLimit',
      displayUnit: 'A',
      transform: 'writeMultiply',
      transformFactor: 100,
      constraint: { min: 0, max: 655.35 },
    },
  },
  BAT_CONFIG_CURRENT_DISCHARGE_LIMIT: {
    address: 0x104C,
    name: 'Battery current discharge limit',
    dataType: DataType.U16,
    unit: 'A',
    accuracy: 0.01,
    access: ReadWrite.ReadWrite,
    description: 'Battery current discharge limit',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'batteryCurrentDischargeLimit',
      displayUnit: 'A',
      transform: 'writeMultiply',
      transformFactor: 100,
      constraint: { min: 0, max: 655.35 },
    },
  },
  BAT_DEPTH_OF_DISCHARGE: {
    address: 0x104D,
    name: 'Battery depth of discharge',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery depth of discharge',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'batteryDepthOfDischarge',
      displayUnit: '%',
      constraint: { min: 10, max: 90 },
    },
  },
  BAT_END_OF_DISCHARGE: {
    address: 0x104E,
    name: 'Battery end of discharge',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery end of discharge',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'batteryEndOfDischarge',
      displayUnit: '%',
      constraint: { min: 10, max: 90 },
    },
  },
  BAT_CONFIG_CONTROL: {
    address: 0x1053,
    name: 'Battery configuration control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery configuration control',
    quantity: 1,
  },
}

const V3BatteryMultipleBatConfig: Partial<RegisterTable> = {
  BAT_CONFIG_ADDRESS_2: {
    address: 0x1054,
    name: 'Battery address 2',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery address 2',
    quantity: 1,
  },
  BAT_CONFIG_ADDRESS_3: {
    address: 0x1055,
    name: 'Battery address 3',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery address 3',
    quantity: 1,
  },
  BAT_CONFIG_ADDRESS_4: {
    address: 0x1056,
    name: 'Battery address 4',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery address 4',
    quantity: 1,
  },
}

export const V3BatterySettings: Partial<RegisterTable> = {
  ...V3BatterySingleBatConfig,
  ...V3BatteryMultipleBatConfig,
};

export const V3InputModeChannels: Partial<RegisterTable> = {
  ...V3DeviceInputTypeChannelConfig,
  PV_InputMode_Config: {
    address: 0x1010,
    name: 'PV input Mode Selection',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'PV input Mode Selection  0: Parallel Mode 1:Independent mode',
    quantity: 1,
  },
  AddressMask_Realtime_Input_Bat1: {
    address: 0x0600,
    name: 'AddressMask_Realtime_Input_Bat1',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of battery 1',
    quantity: 4,
    isMask: true,
  },
  AddressMask_Realtime_Input_PV1: {
    address: 0x0580,
    name: 'AddressMask_Realtime_Input_PV1',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address Mask Realtime Input PV1',
    quantity: 4,
    isMask: true,
  },
};

export const V3DevicePCCSettings: Partial<RegisterTable> = {
  PCCSampleMode: {
    address: 0x1060,
    name: 'PCCSampleMode',
    dataType: DataType.U16,
    description: `
    PCC power acquisition device configuration
    0: not used
    1: Electricity meter
    2: CT
    3: ARPC`,
    access: ReadWrite.ReadWrite,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'PCCSampleMode',
      options: [
        { value: 0, label: 'Not Used' },
        { value: 1, label: 'Electricity Meter' },
        { value: 2, label: 'CT' },
        { value: 3, label: 'ARPC' },
      ],
    },
  },
};

export const V3AntiRefluxSettings: Partial<RegisterTable> = {
  AntiReflux_Control: {
    address: 0x1023,
    name: 'AntiReflux_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      Reflux Power control
      input value 0, disable the reflux power
      input value 1, power reflux enable with minimum power among the three phase
      input value 2, power reflux enable with meaning value`,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'antiRefluxControl',
      options: [
        { value: 0, label: 'disableRefluxPower' },
        { value: 1, label: 'powerRefluxEnableWithMinimumPower' },
        { value: 2, label: 'powerRefluxEnableWithMeaningValue' },
      ],
    },
  },
  AntiReflux_Power: {
    address: 0x1024,
    name: 'AntiReflux_Power',
    dataType: DataType.U16,
    unit: 'W',
    accuracy: 100,
    access: ReadWrite.ReadWrite,
    description: 'Reflux power, 0~65535',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'refluxPower',
      displayUnit: 'W',
      transform: 'writeMultiply',
      transformFactor: 0.01,
      constraint: { min: 0, max: 65535 },
    },
  },
};

export const V3DeviceAntiRefluxAndPCCSettings: Partial<RegisterTable> = {
  ...V3AntiRefluxSettings,
  ...V3DevicePCCSettings,
};

export const V3IVCurveScanSettings: Partial<RegisterTable> = {
    IVCurveScan_Control: {
    address: 0x1025,
    name: 'IVCurveScan_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'IV curve scan control 0: disable, 1: enable',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'IVCurveScanControl',
    },
  },
  IVCurveScan_Period: {
    address: 0x1026,
    name: 'IVCurveScan_Period',
    dataType: DataType.U16,
    unit: 'Minute',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Iv Curve scan cycle time, 5~65535',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'IVCurveScanPeriod',
      displayUnit: 'min',
      constraint: { min: 5, max: 65535 },
    },
  },
};

export const V3EpsSettings: Partial<RegisterTable> = {
  EPS_Control: {
    address: 0x1029,
    name: 'EPS_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      Emergency Power supply
      1: disable emergency power supply
      2 enable emergency power supply ,disable cold start
      3 enable emergency power supply enable cold start`,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'ePSControl',
      options: [
        { value: 0, label: 'disableEmergencyPowerSupply' },
        { value: 2, label: 'enableEmergencyPowerSupplyEnableColdStart' },
      ],
    },
  },
  EPS_WaitTime: {
    address: 0x102a,
    name: 'EPS_WaitTime',
    dataType: DataType.U16,
    unit: 'Second',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Waiting time for emergency power start (Reverse Function)',
    quantity: 1,
  },
};

export const V3BatteryActiveSettings: Partial<RegisterTable> = {
  BatteryActive_Control: {
    address: 0x102b,
    name: 'BatteryActive_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Battery automatic activation, 0: disable, 1: enable',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'batteryActiveControl',
    },
  },
  BatteryActive_Oneshot: {
    address: 0x102c,
    name: 'BatteryActive_Oneshot',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
    Battery active input value 1, enable the battery active one time.  It will return to pervious operation status when you read it.
    0x0000：success
    0x0001：Operating
    0xFFFB：Fail,controller refuse to  response (controller busy or configuration issue）
    0xFFFC：Fail ,Controller no response
    0xFFFD：Fail, Current Function Disable
    0xFFFE：Fail,Parameter can not be save
    0xFFFF：Fail Input Parameters incorrect`,
    quantity: 1,
  },
};

export const V3UnbalancedSupportSettings: Partial<RegisterTable> = {
  UnbalancedSupport_Control: {
    address: 0x1038,
    name: 'UnbalancedSupport_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      3-phase 4-wire mode grid unbalanced support control register
      0: Disable unbalanced support function (default)
      1: Enable unbalanced support function`,
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'unbalancedSupportControl',
    },
  },
};

export const V3ParallelSettings: Partial<RegisterTable> = {
  Parallel_Control: {
    address: 0x1035,
    name: 'Parallel_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
    0: Disable the inverters' parallel function
    1: Enable the inverters' parallel function`,
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'parallelControl',
    },
  },
  Parallel_Master_Slave: {
    address: 0x1036,
    name: 'Parallel_Master_Slave',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Configuration  0: Slave 1:Master',
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'parallelMasterSlave',
      options: [
        { value: 0, label: 'Slave' },
        { value: 1, label: 'Master' },
      ],
    },
  },
  Parallel_Address: {
    address: 0x1037,
    name: 'Parallel_Address',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Parallel address, 0~10',
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'parallelAddress',
      options: Array.from({ length: 11 }, (_, i) => ({ value: i, label: `${i}` })),
    },
  },
};

export const V3ModbusSettings: Partial<RegisterTable> = {
  AddressMask_Config_Basic1: {
    address: 0x1000,
    name: 'AddressMask_Config_Basic1',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of basic configuration 1',
    quantity: 4,
    isMask: true,
  },
  RS485Config_Address: {
    address: 0x100b,
    name: 'RS485Config_Address',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'RS 485 configuration- communication address 1~247',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'rS485ConfigAddress',
      constraint: { min: 1, max: 247 },
    },
  },
  RS485Config_Baud: {
    address: 0x100c,
    name: 'RS485Config_Baud',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      RS485 Baud Rate Selection
      0：4800bps
      1：9600bps（Default）
      2：19200bps
      3：38400bps
      4：57600bps
      5：115200bps
      10：1200bps
      11：2400bps`,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'rS485BaudRateSelection',
      options: [
        { value: 0, label: '4800bps' },
        { value: 1, label: '9600bps (Default)' },
        { value: 2, label: '19200bps' },
        { value: 3, label: '38400bps' },
        { value: 4, label: '57600bps' },
        { value: 5, label: '115200bps' },
        { value: 10, label: '1200bps' },
        { value: 11, label: '2400bps' },
      ],
    },
  },
  RS485Config_StopBit: {
    address: 0x100d,
    name: 'RS485Config_StopBit',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      RS485Stop bit selection；
      0：1bit stop bit（Default）
      1：1.5 bit stop bit
      2：2bit stop bit`,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'rS485StopBitSelection',
      options: [
        { value: 0, label: '1 bit stop bit (Default)' },
        { value: 1, label: '1.5 bit stop bit' },
        { value: 2, label: '2 bit stop bit' },
      ],
    },
  },
  RS485Config_ParityBit: {
    address: 0x100e,
    name: 'RS485Config_ParityBit',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      RS485 check bit selection；
      0：No Check/None（Default）
      1：Even
      2：Odd
      3：HIgh/Mark
      4：Low/Space`,
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'rS485ParityBitSelection',
      options: [
        { value: 0, label: 'noCheckNone' },
        { value: 1, label: 'even' },
        { value: 2, label: 'odd' },
        { value: 3, label: 'highMark' },
        { value: 4, label: 'lowSpace' },
      ],
    },
  },
  RS485Config_Control: {
    address: 0x100f,
    name: 'RS485Config_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: `
      Input value is 1, the value of shadow register in system time will upgrade to the real time.
      It will return to pervious operation status when you read it.
      0x0000：success
      0x0001：Operating
      0xFFFB：Fail,controller refuse to  response (controller busy or configuration issue）
      0xFFFC：Fail ,Controller no response
      0xFFFD：Fail, Current Function Disable
      0xFFFE：Fail,Parameter can not be save
      0xFFFF：Fail Input Parameters incorrect`,
    quantity: 1,
  },
};

export const V3SysTimeConfig: Partial<RegisterTable> = {
  SysTimeConfig_Year: {
    address: 0x1004,
    name: 'SysTimeConfig_Year',
    dataType: DataType.U16,
    unit: 'Year',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'System time - year (actual year = 2000 + register value)',
    quantity: 1,
  },
  SysTimeConfig_Month: {
    address: 0x1005,
    name: 'SysTimeConfig_Month',
    dataType: DataType.U16,
    unit: 'Month',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'System time - month (1–12)',
    quantity: 1,
  },
  SysTimeConfig_Date: {
    address: 0x1006,
    name: 'SysTimeConfig_Date',
    dataType: DataType.U16,
    unit: 'Day',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'System time - day of month (1–31)',
    quantity: 1,
  },
  SysTimeConfig_Hour: {
    address: 0x1007,
    name: 'SysTimeConfig_Hour',
    dataType: DataType.U16,
    unit: 'Hour',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'System time - hour (0–23)',
    quantity: 1,
  },
  SysTimeConfig_Minute: {
    address: 0x1008,
    name: 'SysTimeConfig_Minute',
    dataType: DataType.U16,
    unit: 'Minute',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'System time - minute (0–59)',
    quantity: 1,
  },
  SysTimeConfig_Second: {
    address: 0x1009,
    name: 'SysTimeConfig_Second',
    dataType: DataType.U16,
    unit: 'Second',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'System time - second (0–59)',
    quantity: 1,
  },
  SysTimeConfig_Control: {
    address: 0x100A,
    name: 'SysTimeConfig_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Date configuration enable (write 1 to apply shadow time registers to system time)',
    quantity: 1,
  },
};

export const ComposeV3DeviceModbusSettings: Partial<InverterDataComposer> = {
  RS485Config_Baud: (data: Partial<InverterData>) => {
    const value = data.RS485Config_Baud;
    if (value === undefined || typeof value !== 'number') {
      data.RS485Config_Baud = `N/A`;
    } else {
      switch (value) {
        case 0:
          data.RS485Config_Baud = `4800bps`;
          break;
        case 1:
          data.RS485Config_Baud = `9600bps`;
          break;
        case 2:
          data.RS485Config_Baud = `19200bps`;
          break;
        case 3:
          data.RS485Config_Baud = `38400bps`;
          break;
        case 4:
          data.RS485Config_Baud = `57600bps`;
          break;
        case 5:
          data.RS485Config_Baud = `115200bps`;
          break;
        case 10:
          data.RS485Config_Baud = `1200bps`;
          break;
        case 11:
          data.RS485Config_Baud = `2400bps`;
          break;
        default:
          data.RS485Config_Baud = `N/A`;
          break;
      };
    }
    return data;
  },
  RS485Config_StopBit: (data: Partial<InverterData>) => {
    const value = data.RS485Config_StopBit;
    if (value === undefined || typeof value !== 'number') {
      data.RS485Config_StopBit = `N/A`;
    } else {
      switch (value) {
        case 0:
          data.RS485Config_StopBit = `1bit`;
          break;
        case 1:
          data.RS485Config_StopBit = `1.5 bit`;
          break;
        case 2:
          data.RS485Config_StopBit = `2bit`;
          break;
        default:
          data.RS485Config_StopBit = `N/A`;
          break;
      };
    }
    return data;
  },
  RS485Config_ParityBit: (data: Partial<InverterData>) => {
    const value = data.RS485Config_ParityBit;
    if (value === undefined || typeof value !== 'number') {
      data.RS485Config_ParityBit = `N/A`;
    } else {
      switch (value) {
        case 0:
          data.RS485Config_ParityBit = `No Check/None`;
          break;
        case 1:
          data.RS485Config_ParityBit = `Even`;
          break;
        case 2:
          data.RS485Config_ParityBit = `Odd`;
          break;
        case 3:
          data.RS485Config_ParityBit = `HIgh/Mark`;
          break;
        case 4:
          data.RS485Config_ParityBit = `Low/Space`;
          break;
        default:
          data.RS485Config_ParityBit = `N/A`;
          break;
      };
    }
    return data;
  },
};

export const ComposeV3DeviceSysTimeConfig: Partial<InverterDataComposer> = {
    SysTimeConfig: (data: Partial<InverterData>) => {
    const y = data.SysTimeConfig_Year;
    const m = data.SysTimeConfig_Month;
    const d = data.SysTimeConfig_Date;
    const h = data.SysTimeConfig_Hour;
    const min = data.SysTimeConfig_Minute;
    const s = data.SysTimeConfig_Second;
    if (
      typeof y === 'number' &&
      typeof m === 'number' &&
      typeof d === 'number' &&
      typeof h === 'number' &&
      typeof min === 'number' &&
      typeof s === 'number'
    ) {
      const pad = (n: number) => n.toString().padStart(2, '0');
      data.SystemTime = `${2000 + y}-${pad(m)}-${pad(d)} ${pad(h)}:${pad(min)}:${pad(s)}`;
    }
    return data;
  },
};

export const V3PurchasePowerLimitSettings: Partial<RegisterTable> = {
  Purchase_Total_Power_Limit_Enable: {
    address: 0x106A,
    name: 'Purchase_Total_Power_Limit_Enable',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Purchase total power limit enable control (0: disabled, 1: enabled)',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'purchasePowerLimitControl',
    },
  },
  Purchase_Total_Power_Limit_Value: {
    address: 0x106B,
    name: 'Purchase_Total_Power_Limit_Value',
    dataType: DataType.U16,
    unit: 'W',
    accuracy: 100,
    access: ReadWrite.ReadWrite,
    description: 'Total power limit for purchasing electricity, 0~65535 (unit: 0.1kW)',
    quantity: 1,
    ui: {
      fieldType: 'input',
      inputType: 'number',
      labelKey: 'purchasePowerLimitValue',
      displayUnit: 'W',
      transform: 'writeMultiply',
      transformFactor: 0.01,
      constraint: { min: 3000, max: 65535 },
    },
  },
};

export const V3RemoteOnOffSettings: Partial<RegisterTable> = {
  AddressMask_Config_Remote1: {
    address: 0x1100,
    name: 'AddressMask_Config_Remote1',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of remote configuration 1',
    quantity: 4,
    isMask: true,
  },
  Remote_On_Off_Control: {
    address: 0x1104,
    name: 'Remote_On_Off_Control',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Remote power on/off. 0x0000: Power off, 0x0001: Power on',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'remoteOnOffControl',
    },
  },
};

export const V3HeatingFilmSettings: Partial<RegisterTable> = {
  AddressMask_Config_Basic1: {
    address: 0x1000,
    name: 'AddressMask_Config_Basic1',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of basic configuration 1',
    quantity: 4,
    isMask: true,
  },
  Heating_Film_Enable: {
    address: 0x102f,
    name: 'Heating_Film_Enable',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Heating film enable: 0: Disable, 1: Enable',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'heatingFilmEnable',
    },
  },
};

export const V3CTDirectionSettings: Partial<RegisterTable> = {
  AddressMask_Config_Basic2: {
    address: 0x1040,
    name: 'AddressMask_Config_Basic2',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of basic configuration 2',
    quantity: 4,
    isMask: true,
  },
  CT_Direction: {
    address: 0x107b,
    name: 'CT_Direction',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'CT Direction. 0: Sell electricity, 1: Buy electricity',
    quantity: 1,
    ui: {
      fieldType: 'select',
      labelKey: 'ctDirection',
      options: [
        { value: 0, label: 'ctDirectionSell' },
        { value: 1, label: 'ctDirectionBuy' },
      ],
    },
  },
  Emergency_Shutdown: {
    address: 0x107c,
    name: 'Emergency_Shutdown',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Emergency shutdown control. 0: Disable, 1: Enable',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'emergencyShutdown',
    },
  },
};

export const V3ArcingAlarmSettings: Partial<RegisterTable> = {
  AddressMask_Config_Basic3: {
    address: 0x1080,
    name: 'AddressMask_Config_Basic3',
    dataType: DataType.U64,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Address mask of basic configuration 3',
    quantity: 4,
    isMask: true,
  },
  ArcingAlarmEnable: {
    address: 0x1084,
    name: 'ArcingAlarmEnable',
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.ReadWrite,
    description: 'Arc detection function. 0: Off, 1: Enable',
    quantity: 1,
    ui: {
      fieldType: 'checkbox',
      labelKey: 'arcingAlarmEnable',
    },
  },
};

export const InverterLanguage ={
  English: 1,
  Italian: 2,
};
